import gql from "graphql-tag";

export const CONSISTENCY_QUERY = gql`
  query consistency($month:Date!) {
    consistency(month:$month)
  }
`;